import {apiRegister} from '../../common/api'
import {isPlain, isArray, forEach} from '../../utils/base'
import { ERR_DATA_NOT_LIST, ERR_DATA_NOT_OBJECT } from '../../const'

/**
 * 声明接口：military.ranking.money
 * 金币收益榜
 */
export const moneyRanking = apiRegister('military.ranking.money', {
    path : '/award/updown2016/rankrecordlist/',
    checkResult: function(R) {
        if(!isArray(R.list)){
            return ERR_DATA_NOT_LIST
        }
        return 0
    },
    formatResult (R){
        let {list,userInfosMap} = R
        if(list){
            forEach(list, function(TR){
                TR.userInfo = userInfosMap[TR.uid] ? userInfosMap[TR.uid] : {}
            })
        }
        return R
    }
}).send

/**
 * 声明接口：military.ranking.win
 * 战绩榜
 */
export const winRanking = apiRegister('military.ranking.win', {
    path : '/award/updown2016/rankuserswin/',
    checkResult: function(R) {
        if(!isArray(R.list)){
            return ERR_DATA_NOT_LIST
        }
        return 0
    },
    formatResult (R){
        let {list,userInfosMap} = R
        if(list){
            forEach(list, function(TR){
                TR.userInfo = userInfosMap[TR.uid] ? userInfosMap[TR.uid] : {}
            })
        }
        return R
    }
}).send

/**
 * 声明接口：military.ranking.combat
 * 竞猜英雄榜
 * id 944
 * /award/updown2016/getbetlist/
 * 参数名称	参数类型	说明
 * date	date	当日(例：2019-01-23)
 * start	int	分页默认0
 * pageNum	int	每页数量默认5
 */
export const combatRanking = apiRegister('military.ranking.combat', {
    path : '/award/updown2016/getbetlist/',
    checkResult: function(R) {
        if(!isArray(R.rankList)){
            return ERR_DATA_NOT_LIST
        }
        return 0
    },
    formatResult (R){
        let {rankList,myBetInfo, userInfosMap} = R
        let list = []
        if(rankList && rankList.length>0){
            forEach(rankList, function(TR){
                TR.userInfo = userInfosMap[TR.uid] ? userInfosMap[TR.uid] : {}
            })
        }
        if(R.myBetInfo){
            R.myBetInfo.userInfo = userInfosMap[R.myBetInfo.uid]
        }
        return R
    }
}).send
/**
 * 周连中榜
 * 竞猜英雄榜
 * id 951
 * /award/updown2016/weekrank/
 * 参数名称	参数类型	说明
 * start	int	分页(默认0)
 * pageNum	int	每页数(默认10)
 */
export const weekRanking = apiRegister('updown.weekrank', {
    path : '/award/updown2016/weekrank/',
    checkResult: function(R) {
        if(!isArray(R.list)){
            return ERR_DATA_NOT_LIST
        }
        return 0
    },
    formatResult (R){
        let {list, userInfosMap} = R
        if(list && list.length>0){
            forEach(list, function(TR){
                TR.userInfo = userInfosMap[TR.uid] ? userInfosMap[TR.uid] : {}
            })
        }
        return R
    }
}).send